import { defineStore } from 'pinia';

export const useDiscountStore = defineStore('discount', {
    state: () => ({
        discountApplicable: false,
        discountAmount: 0,
        discountObject: []
    }),
    actions: {
        setDiscount(isApplicable, amount, discountObject) {
            this.discountApplicable = isApplicable;
            this.discountAmount = amount;
            this.discountObject = discountObject;
        }
    }
});
